import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PPDAY_65: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_PPDAY_65_N,
  },
  {
    pageId: PageId.CHAT_UPSELL_PPDAY_65,
  },
  {
    pageId: PageId.UPSELL_PPDAY_65,
  },
  {
    pageId: PageId.DOWNLOAD_PPDAY_65,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
